// Branch detection utility
export const getCurrentBranch = () => {
  // Prefer explicit environment variables injected at build time (CI/CD)
  if (process.env.REACT_APP_BRANCH) {
    return process.env.REACT_APP_BRANCH;
  }

  if (process.env.REACT_APP_VERCEL_GIT_COMMIT_REF) {
    return process.env.REACT_APP_VERCEL_GIT_COMMIT_REF;
  }

  if (process.env.REACT_APP_NETLIFY_GIT_COMMIT_REF) {
    return process.env.REACT_APP_NETLIFY_GIT_COMMIT_REF;
  }

  // Allow the hosting environment to inject a branch via the window object
  if (typeof window !== "undefined" && window.__ENV_BRANCH__) {
    return window.__ENV_BRANCH__;
  }

  // Fallback for local development when no env var is configured
  if (process.env.NODE_ENV === "development") {
    return "local";
  }

  return "unknown";
};

// Check if we're on a production branch
export const isProductionBranch = () => {
  // Check NODE_ENV first as a reliable production indicator
  if (process.env.NODE_ENV === "production") {
    return true;
  }

  const branch = getCurrentBranch();
  return branch === "master" || branch === "NZ_Frontend";
};

// Get API configuration based on branch
export const getApiConfig = () => {
  const isProduction = isProductionBranch();
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (isProduction) {
    return {
      apiUrl: "https://api.conciergecarwash.com.au/v1/",
      environment: "production",
    };
  } else {
    // Use localhost for local development, custom domain for staging deployments
    // Update the staging URL once custom domain and SSL are configured
    return {
      apiUrl: isLocalhost
        ? "http://localhost:8090/v1/"
        : "https://ccw-staging-api.conciergecarwash.com.au/v1/", // Update with your custom domain
      environment: "staging",
    };
  }
};

// Get Stripe configuration based on branch
export const getStripeConfig = () => {
  const isProduction = isProductionBranch();

  if (isProduction) {
    return {
      publishableKey:
        "pk_live_51J66hXJYg37oJgwIyk46rPD8zdvw1tplX8IhYmSUZBjVoXC4jjuOyQh8zdsUBbHF8OPgzEJ6aXajQdcH8he9lwwm002jxzMpSP", // Production key
      environment: "production",
    };
  } else {
    return {
      publishableKey:
        "pk_test_51J66hXJYg37oJgwIHM4ROU4wRB1SNZuOs6DoeFcIKPMUWt8lQaLAq2rBsjURZMaIYQtzVVopfeo4PYwupM4mA6Lf00PtPJLgg3", // Staging key
      environment: "staging",
    };
  }
};

// Get other environment-specific configurations
export const getEnvironmentConfig = () => {
  const isProduction = isProductionBranch();
  // const isProduction = false;

  return {
    isProduction,
    branch: getCurrentBranch(),
    api: getApiConfig(),
    stripe: getStripeConfig(),
    // Add other environment-specific configs here
    bookingUrl: isProduction
      ? "https://booking.conciergecarwash.com.au/"
      : "https://localhost:3000/",
    promotionalUrl: isProduction
      ? "https://conciergecarwash.com.au/"
      : "https://localhost:3000/",
  };
};
